'use client';
import { useEffect } from 'react';
import t from 'tiny-warning';
import { isProduction } from '../../core/utilities/env.utils.js';

let i = [];
function useDeprecatedProps(n, o, p) {
    useEffect(()=>{
        isProduction() || p.forEach((e)=>{
            let { propName: t$1, deprecatedValues: p, instructions: l = '' } = e;
            if (o.__dangerouslySuppressWarning) return;
            let s = o[t$1];
            if (void 0 === s) return;
            let $ = '', a = '', f = String(t$1), c = String(s), u = Array.isArray(p);
            if (p && (u && p.length > 0 || Object.keys(p).length > 0)) {
                if (u ? p.includes(c) : c in p) {
                    let e = u ? l : p[c];
                    $ = `The "${f}"="${c}" prop value of "${n}" is deprecated. ${e}`, a = `${n}-${f}-${c}`;
                }
            } else $ = `The "${f}" prop of "${n}" is deprecated. ${l}`, a = `${n}-${f}`;
            let d = '' !== $ && !i.includes(a);
            t(!d, $), d && i.push(a);
        });
    }, [
        n,
        o,
        p
    ]);
}

export { useDeprecatedProps };
